const currencyFormatter = require('currency-formatter');

const StripeAmountCalculator = {
    install(Vue, options){
        Vue.mixin({
            methods:{
                stripeAmount(amountFromStripe){
                    const amount = amountFromStripe / 100;
                    const taxes = amount * 0.2;

                    return {
                        amount:String(currencyFormatter.format(amount, {
                            locale: 'da-DK',
                            precision: (amount % 1 !== 0) ? 2:0,
                            symbol:'',
                            thousand: '.',
                        })).trim(),
                        taxes:String(currencyFormatter.format(taxes, {
                            locale: 'da-DK',
                            precision: (taxes % 1 !== 0) ? 2:0,
                            symbol:'',
                            thousand: '.',
                        })).trim(),
                        amountWithoutTaxes: String(currencyFormatter.format(amount - taxes, {
                            locale: 'da-DK',
                            precision:((amount - taxes) % 1 !== 0) ? 2:0,
                            symbol:'',
                            thousand: '.',
                        })).trim(),
                        amountForEditing: amount,
                    }
                },
                amountToStripe(amount){
                    return amount * 100;
                }
            },
        })
    }
};

export default StripeAmountCalculator;